import { Grid2 } from '@mui/material';
import React, { useCallback } from 'react';
import { TMaterialStyles } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { ButtonWithShadow } from '../../Buttons/ButtonWithShadow';
import TypographyWithShadow from '../../Typography/TypographyWithShadow';

interface IToggleViewButtons {
  setActiveView: (value: boolean) => void;
  isStreetView: boolean;
  onSubmit: () => Promise<void>;
  coordinates: {
    lat: number;
    lng: number;
  } | null;
}

const toggleViewButtons: React.FC<IToggleViewButtons> = ({
  setActiveView,
  isStreetView,
  onSubmit,
  coordinates,
}) => {
  const showStreetView = useCallback(() => {
    setActiveView(true);
  }, [setActiveView]);

  const showWorldMap = useCallback(() => {
    setActiveView(false);
  }, [setActiveView]);

  const { t } = useTranslation();

  return (
    <Grid2 sx={materialStyles.container}>
      {!isStreetView ? (
        <>
          <ButtonWithShadow
            type="PRIMARY"
            sx={materialStyles.toggleViewButton}
            onClick={showStreetView}
          >
            <TypographyWithShadow
              shadowType="DARK"
              sx={materialStyles.buttonText}
            >
              {t('game.back_to_panorama')}
            </TypographyWithShadow>
          </ButtonWithShadow>

          <ButtonWithShadow
            type={coordinates ? 'PRIMARY' : 'DISABLED'}
            onClick={onSubmit}
            sx={materialStyles.submitBtn}
            disabled={!coordinates}
          >
            <TypographyWithShadow
              shadowType="DARK"
              sx={materialStyles.submitBtnText}
            >
              {t('game.submit')}
            </TypographyWithShadow>
          </ButtonWithShadow>
        </>
      ) : (
        <ButtonWithShadow
          type="PRIMARY"
          sx={materialStyles.toggleViewButton}
          onClick={showWorldMap}
        >
          <TypographyWithShadow
            shadowType="DARK"
            sx={materialStyles.buttonText}
          >
            {t('game.choose_location')}
          </TypographyWithShadow>
        </ButtonWithShadow>
      )}
    </Grid2>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'row',
  },
  toggleViewButton: {
    borderRadius: '14px',
    p: '18px',
    width: '207px',
    height: '47px',
  },
  buttonText: {
    fontSize: '19px',
    fontFamily: 'Rubber Duck !important',
  },
  submitBtn: {
    borderRadius: '14px',
    p: '18px',
    width: '103px',
    height: '47px',
    ml: '20px',
  },
  submitBtnText: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '19px',
  },
};

export default toggleViewButtons;
